define.alias("ember-math-helpers/helpers/imul", "media/helpers/imul");